// extracted by mini-css-extract-plugin
export default {"cta":"AI-z","disabled":"BI-z"};